module.exports = __webpack_public_path__ + "static/media/Point 2.0d82051d.png";